// Generated by ReScript, PLEASE EDIT WITH CARE


let targetOrigin = "*";

export {
  targetOrigin,
}
/* No side effect */
